var bighouse = bighouse || {};

bighouse.header = (function () {

    var stickyHeader, st, headerHeight;

    function init() {
        stickyHeader = $(".js-stickyNavHeader").sticky({
            topSpacing: 0
        });

  

       var debounceResize = util.debounce(resizeHeader, 200);
       $(window).on('resize', debounceResize);

        
        var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
        window.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
            st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

            mainHeader(st, lastScrollTop);
            if($('.js-bookingBar').length > 0) bookingBar(st);
            homepageClass();

            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        }, false);

    }

    function mainHeader(st, lastScrollTop){
        
        headerHeight = $(".js-stickyNavHeader").outerHeight();

        if (st > lastScrollTop && !$(".js-stickyNavHeader").hasClass('js-stickyNavHeader--down') ){
            // downscroll code
            if(st < headerHeight){
                $(".js-stickyNavHeader").css('margin-top', '0px');  
            } else {
                $(".js-stickyNavHeader").addClass('js-stickyNavHeader--down');
                $(".js-stickyNavHeader").css('margin-top', '-' + headerHeight + 'px');  
                bighouse.nav.close();
            }
            $(".js-filterStickyBtn").removeClass('SearchResults-filterBtn--headerMove');        
        } else if( (st <= lastScrollTop ) && $(".js-stickyNavHeader").hasClass('js-stickyNavHeader--down')) {
            // upscroll code
            $(".js-stickyNavHeader").removeClass('js-stickyNavHeader--down');
            $(".js-stickyNavHeader").css('margin-top', '0px');
            $(".js-filterStickyBtn").addClass('SearchResults-filterBtn--headerMove');
        }
    }

    
    function bookingBar(st){
        //only show the booking bar if user has scrolled past a certain point

        var scrollTopShow = $('.js-showBookingBar').offset().top;
        var scrollTopHide = $('.js-hideBookingBar').offset().top - $( window ).height();

        if(st > scrollTopShow && st < scrollTopHide){
            $('.js-bookingBar').addClass('js-bookingBar--visible');
        } else {
            $('.js-bookingBar').removeClass('js-bookingBar--visible');
        }
    }


    function resizeHeader(){
        stickyHeader.sticky('update');
    }

    function homepageClass(){
        if( $('.Header--homepage').length > 0 ){
            if(st < headerHeight && $('.Header--openMenu').length === 0 ){
                $(".js-stickyNavHeader").removeClass('js-stickyNavHeader--hasBG');
            } else {
                $(".js-stickyNavHeader").addClass('js-stickyNavHeader--hasBG');
            }
        }
    }



    return {
        init: init,
        homepageClass: homepageClass
    };
})();